<template>
  <GeneralDashboardLayout>
    <template v-slot:header>
      <div class="header-template">
        <BackButton :to="{ name: 'panel_agenda.index' }" />
        <h1 class="title text-center">Edit Panelist</h1>
        <div>
          <button class="btn btn-outline-primary" @click="createClick">Update</button>
          <button class="btn btn-outline-primary" @click="cancelClick">Cancel</button>
        </div>
      </div>
    </template>
    <template v-slot:content>
      <div class="container-fluid panel-container">
        <PanelistEdit />
        <FlashMessage group="panelist_edit" />
      </div>
    </template>
  </GeneralDashboardLayout>
</template>

<script>
import BackButton from "@/components/Commons/BackButton";
import GeneralDashboardLayout from "@/components/layouts/GeneralDashboardLayout";
// import TogglePrimary from "@/components/Commons/TogglePrimary";
// import PanelistEdit from "@/components/cruds/PanelAgenda/Panelists/Edit";

export default {
  name: "PanelAgendaPanelistEdit",
  components: {
    // PanelistEdit,
    // TogglePrimary,
    BackButton,
    GeneralDashboardLayout,
  },
  beforeUnmount() {
    delete this.$flashMessage.groups.panelist_edit;
  },
  methods: {
    createClick() {

    },
    cancelClick() {

    },
  }
}
</script>

<style scoped>

</style>